import type { IAppProps } from '@/interfaces/IAppProps'
import type { IGlobalStore } from '@/interfaces/IGlobalStore'
import type { IMainToggle } from '@/interfaces/IMainToggle'
import { Amount } from '@nami/domain/classes'
import { acceptHMRUpdate, defineStore } from 'pinia'
import { toRefs } from 'vue'
import { useUserStore } from '@/stores/userStore'
import { isMobile } from '@/utils/shared'

export const useGlobalStore = defineStore('GlobalStore', {
    state: (): IGlobalStore => ({
        requestStack: [],
        balanceDisplay: '',
        appProps: {} as IAppProps,
        balanceNumber: 0,
        mainToggle: {
            mainToggleHistoryRedPoint: false,
            toggleEnableWithdrawableAmountCurrencies: [],
            toggleRefreshAutoWithdrawBalance: false,
            toggleVerifyEwalletAccountStatusPaymentMethods: {},
            toggleWithdrawableAmount: false,
            toggleRequiredKyc: false,
            toggleDisplayBonusWalletAmount: false,
            adFortuneTrackingOpenCountries: [],
            toggleOtpCurrency: [],
            blockPaymentMethodConfig: [],
            usdtNotSupportedCountries: [],
        },
        isToggleReady: false,
        withdrawableAmountNumber: 0,
        nonWithdrawableAmountNumber: 0,
        withdrawableLastUpdateTime: null as unknown as Date,
    }),
    getters: {
        balanceAmount(): Amount {
            const { userInfo } = toRefs(useUserStore())
            return Amount.createBySboAmount(this.balanceNumber, userInfo.value.currency)
        },
    },
    actions: {
        goBack(homeUrl: string) {
            if (homeUrl === 'close') {
                window.close()
            }
            else {
                window.location.href = homeUrl || '/payment/deposit'
            }
        },
        isShowLoading(type: boolean) {
            if (type) {
                this.addProcessApi(new Date().toISOString())
            }
            else {
                this.requestStack.splice(0, this.requestStack.length)
            }
        },
        addProcessApi(url: string) {
            this.deleteProcessApi(url)
            this.requestStack.push(url)
        },
        deleteProcessApi(url: string) {
            if (!url && this.requestStack.length > 0) {
                this.requestStack.splice(0, this.requestStack.length)
                return
            }
            const index = this.requestStack.indexOf(url)
            if (index !== -1) {
                this.requestStack.splice(index, 1)
            }
        },
        setBalance(balance: string) {
            this.balanceDisplay = balance
        },
        setBalanceNumber(balance: number) {
            this.balanceNumber = balance
        },
        setWithdrawableAmount(withdrawableAmount: number) {
            this.withdrawableAmountNumber = withdrawableAmount
            this.nonWithdrawableAmountNumber = this.balanceNumber - withdrawableAmount
        },
        setAppProps(appProps: IAppProps) {
            this.appProps = appProps
        },
        setMainToggle(mainToggle: IMainToggle) {
            this.mainToggle = mainToggle
            this.isToggleReady = true
        },
        setLastUpdateTime(lastUpdateTime: Date) {
            this.withdrawableLastUpdateTime = lastUpdateTime
        },
        gtmCode() {
            const { gtmCommonData } = toRefs(useUserStore())
            if (gtmCommonData.value.currency === 'INR') {
                return 'MN5ZFJT'
            }
            if (this.appProps.brandName === 'SBOTOP') {
                return isMobile() ? 'PBB6SRX' : 'M452P4Q'
            }
            else {
                return isMobile() ? 'W8RRLHH' : 'N4NTRL'
            }
        },
    },
})
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useGlobalStore, import.meta.hot))
}
